import React from 'react';
import PropTypes from 'prop-types';
import { StyledLabel } from './style';

const Label = ({ className, label, ...rest }) => (
  <StyledLabel className={className} {...rest}>
    {label}
  </StyledLabel>
);

Label.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

export default Label;
